import { ImagePickerOptions } from 'react-native-image-picker';

export const pickerOptions: ImagePickerOptions = {
  cancelButtonTitle: 'Cancel',
  takePhotoButtonTitle: 'Take Photo...', // specify null or empty string to remove this button
  chooseFromLibraryButtonTitle: 'Choose from Library...', // specify null or empty string to remove this button
  cameraType: 'back', // 'front' or 'back'
  mediaType: 'photo', // 'photo' or 'video'
  tintColor: 'lightBlue',
  // videoQuality: 'medium', // 'low', 'medium', or 'high'
  durationLimit: 10, // video recording max time in seconds
  maxWidth: 1000, // photos only
  maxHeight: 1000, // photos only
  quality: 0.5, // 0 to 1, photos only
  // allowsEditing: true, // Built in functionality to resize/reposition the image after selection
  // photos only - disables the base64 `data` field
  // from being generated (greatly improves performance on large photos)
  noData: false,
  // storageOptions: {
  //   // if this key is provided, the image will get saved in the documents directory on ios,
  //   // and the pictures directory on android (rather than a temporary directory)
  //   skipBackup: true, // ios only - image will NOT be backed up to icloud
  //   path: 'images', // ios only - will save image at /Documents/images rather than the root
  // },
};
